<template>
  <field-frame :field="field" :show-optional="showOptional">
    <div class="flex flex-col gap-2">
      <div
        role="button"
        tabindex="0"
        :aria-label="field.src ? $t('署名し直す (領域をクリックまたはタップ)') : $t('署名する (領域をクリックまたはタップ)')"
        class="signpad-trigger group relative bg-white border-2 border-dashed border-q4cl-border rounded-q4cl p-3 text-center cursor-pointer hover:border-q4cl-accent hover:bg-sky-50 focus-visible:outline-none focus-visible:border-q4cl-accent focus-visible:ring-2 focus-visible:ring-q4cl-accent transition-colors"
        @click="openSignpad"
        @keydown.enter.prevent="openSignpad"
        @keydown.space.prevent="openSignpad"
      >
        <img v-if="field.src" :src="field.src" class="max-w-full mx-auto" :alt="$t('署名')" />
        <div v-else class="text-q4cl-muted text-sm py-8 flex flex-col items-center gap-2">
          <i class="fa-solid fa-signature text-3xl text-q4cl-border group-hover:text-q4cl-accent transition-colors" aria-hidden="true"></i>
          <span>{{ $t('ここをクリックまたはタップして署名してください') }}</span>
        </div>
        <div v-if="field.src" class="absolute inset-0 bg-q4cl-primary/0 group-hover:bg-q4cl-primary/5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all pointer-events-none">
          <span class="text-xs font-bold text-q4cl-primary bg-white/90 px-3 py-1 rounded-full shadow">
            <i class="fa-solid fa-pen mr-1" aria-hidden="true"></i>{{ $t('クリックで署名し直す') }}
          </span>
        </div>
      </div>
      <div v-if="field.src" class="flex justify-end">
        <button type="button" class="btn-secondary !py-1 !px-3 text-xs" @click="clearSig">
          <i class="fa-solid fa-trash-can mr-1" aria-hidden="true"></i>{{ $t('クリア') }}
        </button>
      </div>
    </div>
    <modal-signpad v-if="open" :initial="field.src" @close="open = false" @save="onSave" />
  </field-frame>
</template>

<script>
import FieldFrame from '@/components/ui/FieldFrame.vue'
import ModalSignpad from '@/components/modals/ModalSignpad.vue'
export default {
  name: 'SignpadField',
  components: {
    'field-frame': FieldFrame,
    'modal-signpad': ModalSignpad
  },
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    const open = Vue.ref(false);
    function openSignpad() { open.value = true; }
    async function onSave(dataUrl) {
      const enc = window.encryption;
      props.field.src = dataUrl;
      props.field.encryptedImgData = await enc.encryptStrWithHash(dataUrl);
      open.value = false;
    }
    function clearSig() {
      props.field.src = '';
      props.field.encryptedImgData = '';
    }
    return { open, openSignpad, onSave, clearSig };
  }
};
</script>
